<template>
  <div>
    <b-alert
      variant="danger"
      :show="refundDetail === null"
      v-if="!refundDetail"
    >
      <h4 class="alert-heading">
        Error fetching Refund Request Detail
      </h4>
      <div class="alert-body">
        <b-link class="alert-link" :to="{ name: 'refundQueue-index' }">
          <feather-icon icon="ArrowLeftIcon" /> Go Back to List
        </b-link>
        to Refund Request And Try again.
      </div>
    </b-alert>
    <b-card v-if="refundDetail">
      <b-row>
        <b-col md="3">
          <b-link :to="{ name: 'refundQueue-index' }">
            <feather-icon icon="ArrowLeftIcon" />
            <span class="align-middle ml-50">Back to List</span>
          </b-link>
        </b-col>
      </b-row>

      <b-card-header>
        <h3>Refund Request Detail</h3>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col md="4">
            <b-form-group>
              <strong> Custom Order Code: </strong>
              <span> {{ refundDetail.customOrderCode }} </span>
            </b-form-group>
            <b-form-group>
              <strong> FlyGate Order Id: </strong>
              <span> {{ refundDetail.flyGateOrderId }} </span>
            </b-form-group>
            <b-form-group>
              <strong> First Name: </strong>
              <span>{{ refundDetail.firstName }} </span>
            </b-form-group>
            <b-form-group>
              <strong> Last Name: </strong>
              <span> {{ refundDetail.lastName }}</span>
            </b-form-group>
            <b-form-group>
              <strong> Order Amount: </strong>
              <span> {{ refundDetail.orderAmount }} </span>
            </b-form-group>
            <b-form-group>
              <strong> Currency: </strong>
              <span> {{ refundDetail.currency }}</span>
            </b-form-group>
            <b-form-group>
              <strong> Paid FOP: </strong>
              <span> {{ refundDetail.paidFOP }} </span>
            </b-form-group>
            <b-form-group>
              <strong> Vendor TxnRef. Number: </strong>
              <span> {{ refundDetail.vendorTxnRefNumber }} </span>
            </b-form-group>
            <b-form-group>
              <strong> Paid Date: </strong>
              <span> {{ refundDetail.paidDate }} </span>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <strong> Refund Requested Date: </strong>
              <span>{{ refundDetail.refundRequestedDateString }}</span>
            </b-form-group>
            <b-form-group>
              <strong> Refund Reference Code: </strong>
              <span> {{ refundDetail.refundReferenceCode }} </span>
            </b-form-group>
            <b-form-group>
              <strong> Refund Merchant Request Code: </strong>
              <span>
                {{ refundDetail.refundMerchantRequestCode }}
              </span>
            </b-form-group>
            <b-form-group>
              <strong> Refund Requested Amount: </strong>
              <span>
                {{ refundDetail.refundRequestedAmount }}
              </span>
            </b-form-group>

            <b-form-group>
              <strong> Ticket Number: </strong>
              <span> {{ refundDetail.originalTicketNumber }} </span>
            </b-form-group>
            <b-form-group>
              <strong> Refund Queue Date : </strong>
              <span> {{ refundDetail.refundQueueDate }} </span>
            </b-form-group>
            <b-form-group>
              <strong> Refund Status: </strong>
              <span>
                {{ refundDetail.refundStatus == 0
                  ? "Not Requested"
                  : refundDetail.refundStatus == 1
                  ? "Pending"
                  : refundDetail.refundStatus == 2
                  ? "Submitted"
                  : refundDetail.refundStatus == 3
                  ? "Approved"
                  : refundDetail.refundStatus == 4
                  ? "Sent"
                  : refundDetail.refundStatus == 5
                  ? "Rejected"
                  : refundDetail.refundStatus == 6
                  ? "Completed"
                  : null, }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <strong> Approver Name : </strong>
              <span>
                {{
                  refundDetail.approverFirstName +
                    " " +
                    refundDetail.approverLastName
                }}
              </span>
            </b-form-group>
            <b-form-group>
              <strong> Approver Email : </strong>
              <span>
                {{ refundDetail.approverEmail }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>

      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BCard,
  BCardBody,
  BCardHeader,
  BOverlay,
  BLink,
} from "bootstrap-vue";

import axios from "@axios";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BCard,
    BCardBody,
    BCardHeader,
    BOverlay,
    BLink,
  },
  props: {
    refundrequest: {
      type: Object,
    },
  },
  data() {
    return {
      refundDetail: this.refundrequest ? this.refundrequest : null,
      isLoading: false,
    };
  },
  created() {
    console.log();
    this.fetchData();
  },
  methods: {
    fetchData() {
      //   this.$store.dispatch("config/getActionPrivilege", "Order-Detail");
      //   axios
      //     .get(`/Order/api/V1.0/Orders/GetOrderById?id=${this.$route.params.id}`)
      //     .then((res) => {
      //       this.isLoading = false;
      //       // console.log(res)
      //       this.detailRefund = res;
      //     })
      //     .catch((res) => {
      //       console.log(res);
      //       this.isLoading = false;
      //     });
    },
  },
};
</script>
<style scoped></style>
